import React from 'react';
import ResetPasswordForm from 'components/ResetPasswordForm';

function ResetPassword() {
  return <ResetPasswordForm />;
}

export default ResetPassword;
